/* SIMPLE QUANTITY BREAKS (sqb) — behaviour. Skill: simple-quantity-breaks (owner's default, 2026-10-01).
   The markup (rendered by the offer snippet) holds the bundle cards, ONE .sqb__in block (an empty .sqb__pks,
   the upsell buttons and the size message) and a JSON config. This script:
   - selects a bundle and moves .sqb__in into its .sqb__slot (upsells live inside the chosen bundle);
   - draws one dropdown picker per unit for the product's option (colour, shade, size, anything);
   - keeps the subtotal right and exposes window.tpoPermalink() / window.tpoMissing() for Buy Now and the
     express button (tp-express.js reads tpoPermalink() after any click on [role=radio] / [role=checkbox]).
   Config: {unit, option, prepick, currency, fmt, main, gift, start, variants:[{id,name,hint,img,available}]} */
(function () {
  if (window.__sqb) return; window.__sqb = 1;
  var CHEV = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9.5l6 6 6-6"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init(root) {
    var cfg = JSON.parse(root.querySelector('script[data-sqb-config]').textContent);
    var tiers = [].slice.call(root.querySelectorAll('.sqb__tier'));
    var inner = root.querySelector('.sqb__in');
    var pkBox = inner.querySelector('.sqb__pks');
    var msg = inner.querySelector('.sqb__msg');
    var adds = [].slice.call(inner.querySelectorAll('.sqb__ad'));
    var totalEl = root.querySelector('[data-sqb-total]');
    var vs = cfg.variants || [];
    var hasPick = !!cfg.option && vs.length > 1;
    var firstAvail = null;
    for (var f = 0; f < vs.length; f++) if (vs[f].available) { firstAvail = vs[f].id; break; }
    for (var g = 0; g < vs.length; g++) if (vs[g].available && String(vs[g].id) === String(cfg.main)) firstAvail = vs[g].id;  // a ?variant= link (a team's ad) pre-picks that variant
    var picks = [], cur = null;

    // the store's own money format (shop.money_format), so the subtotal reads like every Liquid price on the page
    var fmt = cfg.fmt || '';
    if (fmt.indexOf('&') > -1) { var ta = document.createElement('textarea'); ta.innerHTML = fmt; fmt = ta.value; }
    function num(n, d, th, dc) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dc); }
    function money(c) {
      var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
      if (!m) return (cfg.currency || '$') + num(c / 100, 2, ',', '.');
      var v = c / 100, o;
      switch (m[1]) {
        case 'amount_no_decimals': o = num(v, 0, ',', '.'); break;
        case 'amount_with_comma_separator': o = num(v, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': o = num(v, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': o = num(v, 2, "'", '.'); break;
        case 'amount_with_space_separator': o = num(v, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': o = num(v, 0, ' ', ','); break;
        default: o = num(v, 2, ',', '.');
      }
      return fmt.replace(m[0], o);
    }
    function byId(id) { for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id)) return vs[i]; return null; }
    function label(i, n) { return n === 1 ? cfg.option : (cfg.unit + ' ' + (i + 1)); }
    function imgSpan(v) { return v && v.img ? '<span class="sqb__img" style="background-image:url(\'' + esc(v.img) + '\')"></span>' : ''; }

    function pickerHTML(i, n) {
      var v = byId(picks[i]);
      var head = '<button type="button" class="sqb__pkh" aria-expanded="false" data-i="' + i + '">' +
        '<span class="sqb__k">' + esc(label(i, n)) + '</span>' + imgSpan(v) +
        '<span class="sqb__v' + (v ? '' : ' is-empty') + '">' + (v ? esc(v.name) : 'Choose ' + esc(String(cfg.option).toLowerCase())) + '</span>' +
        '<span class="sqb__cv"><span class="sqb__cvt">' + (v ? 'Change' : 'Choose') + '</span>' + CHEV + '</span></button>';
      var list = '<div class="sqb__list" role="radiogroup" aria-label="' + esc(label(i, n)) + '">' + vs.map(function (o) {
        var on = String(o.id) === String(picks[i]);
        return '<button type="button" class="sqb__op" role="radio" aria-checked="' + on + '" data-id="' + esc(o.id) + '"' + (o.available ? '' : ' disabled') + '>' +
          imgSpan(o) + '<span class="sqb__tx"><b>' + esc(o.name) + '</b>' +
          (o.available ? (o.hint ? '<small>' + esc(o.hint) + '</small>' : '') : '<small>Sold out</small>') +
          '</span><span class="sqb__rd"></span></button>';
      }).join('') + '</div>';
      return '<div class="sqb__pk" data-i="' + i + '">' + head + list + '</div>';
    }

    function renderPickers(n) {
      if (!hasPick) { pkBox.innerHTML = ''; return; }
      picks.length = Math.min(picks.length, n);
      for (var i = 0; i < n; i++) {
        if (picks[i] === undefined || picks[i] === null && cfg.prepick) {
          // a new unit starts on the previous unit's colour (or the first available); sizes never pre-pick
          picks[i] = cfg.prepick ? (i > 0 && picks[i - 1] ? picks[i - 1] : firstAvail) : null;
        }
      }
      var html = ''; for (var j = 0; j < n; j++) html += pickerHTML(j, n);
      pkBox.innerHTML = html;
    }

    function closeAll(except) {
      [].forEach.call(pkBox.querySelectorAll('.sqb__pk.is-open'), function (p) {
        if (p === except) return;
        p.classList.remove('is-open');
        var h = p.querySelector('.sqb__pkh'); h.setAttribute('aria-expanded', 'false');
        p.querySelector('.sqb__cvt').textContent = picks[+p.dataset.i] ? 'Change' : 'Choose';
      });
    }
    function toggle(p) {
      var open = !p.classList.contains('is-open');
      closeAll(p);
      p.classList.toggle('is-open', open);
      p.querySelector('.sqb__pkh').setAttribute('aria-expanded', String(open));
      p.querySelector('.sqb__cvt').textContent = open ? 'Close' : (picks[+p.dataset.i] ? 'Change' : 'Choose');
      if (open) { var on = p.querySelector('.sqb__op[aria-checked="true"]') || p.querySelector('.sqb__op:not([disabled])'); if (on) on.focus({ preventScroll: true }); }
    }

    function update() {
      var t = cur ? +cur.dataset.price : 0;
      adds.forEach(function (a) { if (a.getAttribute('aria-checked') === 'true') t += +a.dataset.price; });
      if (totalEl) totalEl.textContent = money(t);
    }

    function select(t) {
      if (!t || t === cur) return;
      cur = t;
      tiers.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', String(on)); x.tabIndex = on ? 0 : -1; });
      t.querySelector('.sqb__slot').appendChild(inner);       // the upsells (and pickers) live inside the chosen bundle
      root.classList.remove('is-missing');
      renderPickers(+t.dataset.qty);
      update();
    }

    root.addEventListener('click', function (e) {
      var el = e.target;
      var op = el.closest('.sqb__op');
      if (op && !op.disabled) {
        var p = op.closest('.sqb__pk'), i = +p.dataset.i;
        picks[i] = op.dataset.id;
        var n = +cur.dataset.qty, rep = document.createElement('div'); rep.innerHTML = pickerHTML(i, n);
        var fresh = rep.firstChild; p.parentNode.replaceChild(fresh, p);
        fresh.querySelector('.sqb__pkh').focus({ preventScroll: true });
        if (!picks.slice(0, n).some(function (x) { return !x; })) root.classList.remove('is-missing');
        return;
      }
      var h = el.closest('.sqb__pkh'); if (h) { toggle(h.closest('.sqb__pk')); return; }
      var a = el.closest('.sqb__ad');
      if (a) { a.setAttribute('aria-checked', String(a.getAttribute('aria-checked') !== 'true')); update(); return; }
      if (el.closest('.sqb__in')) return;
      var t = el.closest('.sqb__tier'); if (t) select(t);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var o = pkBox.querySelector('.sqb__pk.is-open'); if (o) { toggle(o); o.querySelector('.sqb__pkh').focus(); } return; }
      var t = e.target.classList && e.target.classList.contains('sqb__tier') ? e.target : null; if (!t) return;
      var k = tiers.indexOf(t);
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(t); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); var nx = tiers[(k + 1) % tiers.length]; select(nx); nx.focus(); }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); var pv = tiers[(k - 1 + tiers.length) % tiers.length]; select(pv); pv.focus(); }
    });
    // a tap outside closes an open picker - except the tap that just asked for a missing choice (Buy Now, express)
    var keepUntil = 0;
    document.addEventListener('click', function (e) { if (Date.now() < keepUntil) return; if (!root.contains(e.target)) closeAll(); });

    // Buy Now / express: the cart lines for exactly what the box shows. Add-ons and gift first, the product's
    // lines last (checkout lists a permalink's lines in reverse, so the product heads the summary).
    window.tpoPermalink = function () {
      if (!cur) return null;
      var n = +cur.dataset.qty, counts = {}, order = [], i;
      if (hasPick) {
        for (i = 0; i < n; i++) { var id = picks[i]; if (!id) return null; if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; }
      } else { counts[cfg.main] = n; order.push(cfg.main); }
      var lines = [];
      adds.forEach(function (a) { if (a.getAttribute('aria-checked') === 'true') lines.push(a.dataset.vid + ':1'); });
      if (cfg.gift) lines.push(cfg.gift + ':1');
      order.forEach(function (v) { lines.push(v + ':' + counts[v]); });
      return '/cart/' + lines.join(',');
    };
    // Marks and opens the first unit without a choice; returns true when something is missing.
    window.tpoMissing = function () {
      if (!cur || !hasPick) return false;
      var n = +cur.dataset.qty;
      for (var i = 0; i < n; i++) if (!picks[i]) {
        keepUntil = Date.now() + 400;
        root.classList.add('is-missing');
        var p = pkBox.querySelector('.sqb__pk[data-i="' + i + '"]');
        [].forEach.call(pkBox.querySelectorAll('.sqb__pk'), function (q) { q.classList.toggle('is-missing', !picks[+q.dataset.i]); });
        if (p && !p.classList.contains('is-open')) toggle(p);
        if (p) p.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return true;
      }
      return false;
    };

    select(tiers[Math.max(0, (cfg.start || 1) - 1)] || tiers[0]);
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-sqb]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
